import React from 'react';
import { ProgressWithIcon } from 'Packages/FacetDesign/Components/Experimental/ProgressWithIcon';
import { useFundedThreshold } from 'Components/UI/roadmapExplorer/goalsAccordion/useFundedThreshold';
import { FDBodyText, FDProgress, FDStack } from '@facet-wealth/design';

export const RoadmapExplorerGoalFundedProgress = ({
  resource,
  width = 200,
  progressValue = 0,
  progressDescription,
  tooltipTitle = undefined,
  tooltipBody = undefined,
  leftAlignedDescription = undefined,
  rightAlignedDescription = undefined,
  hasIcon = true,
}) => {
  const { funded, threshold } = useFundedThreshold(resource);

  if (hasIcon) {
    return (<ProgressWithIcon
      totalValue={funded}
      progressValue={progressValue}
      icon={threshold.attr('icon')}
      color={threshold.attr('color')}
      width={width}
      tooltipTitle={tooltipTitle}
      tooltipBody={tooltipBody}
      leftAlignedDescription={leftAlignedDescription}
      rightAlignedDescription={rightAlignedDescription}
    />);
  }

  return (
    <FDStack direction={'column'} spacing={1}>
      <FDProgress
        label={progressDescription}
        value={Math.max(progressValue / 100, 0)}
      />
      <FDStack direction={'row'} justifyContent={'flex-end'}>
        <FDBodyText size={'sm'} value={rightAlignedDescription} />
      </FDStack>
    </FDStack>
  );
};
